import { Component, OnInit, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MyProgressChange } from "../../interfaces/my-progress-change";

import { GlobalService } from "../../services/global.service";
import { BsrmhttpService } from "../../services/bsrmhttp.service";
import { Authdata } from "../../classes/authdata.class";
import { BsrmencryptionService } from "src/app/services/bsrmencryption.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent {
  constructor(
    private globalServices: GlobalService,
    private myEncryption: BsrmencryptionService,
    private httpService: BsrmhttpService,
    private router: Router
  ) {}

  companyName: string;
  logUserId: string = "";
  loginForm;
  encMsg: string;
  errorMsg: string;

  ngOnInit() {
    this.companyName = this.globalServices.companyName;

    this.loginForm = new FormGroup({
      UserId: new FormControl("", Validators.compose([Validators.required])),
      Password: new FormControl("", Validators.compose([Validators.required])),
    });

    new Authdata().clearData();
  }
  getVal(a) {
    //console.log(a);
  }
  login(val) {
    this.errorMsg = "";

    let strongPassword = new RegExp(
      "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
    );

    if (!val.UserId || val.UserId.length <= 0) {
      this.errorMsg = "Please provide your account number.";
    } else {
      if (!val.Password || val.Password.length <= 0) {
        this.errorMsg = "Please provide password.";
      } else {
        this.globalServices.showProgressbar();
        this.httpService
          .findKey(val.UserId, encodeURIComponent(val.Password))
          .subscribe(
            (d) => {
              this.globalServices.hideProgressbar();
              console.log(JSON.stringify(d));
              var json = JSON.parse(JSON.stringify(d));
              console.log(json);
              var authData = new Authdata();
              authData.setData(JSON.stringify(json));
              if (json.Key && json.Key.length > 0) {
                var decKey = this.myEncryption.decryptedString(json.Key);
                var stat = decKey.split("|")[1];
                console.log(stat);
                // stat="0";

                if (stat == "0") {
                  this.router.navigateByUrl("resetpassword?key=" + json.Key);
                } else {

                if (!strongPassword.test(val.Password)) {
                  this.router.navigate(["/changepassword"]);
                  return;
                }
                  this.router.navigate(["crm/welcome"]);
              }

               

               
              } else {
                this.router.navigate(["crm/welcome"]);
              }
            },
            (error) => {
              this.globalServices.hideProgressbar();
              this.errorMsg = "Invalid user name or password";
            },
            () => {
              // this.globalServices.hideProgressbar();
            }
          );
      }
    }
  }
  ForgotPassword(val) {
    this.errorMsg = "";
    if (!val.UserId || val.UserId.length <= 0) {
      this.errorMsg = "Please provide your account number.";
      return;
    }
    this.globalServices.showProgressbar();
    this.httpService
      .post("ForgotPassword", { AccountNumber: val.UserId })
      .subscribe(
        (d) => {
          this.globalServices.hideProgressbar();

          var json = JSON.parse(JSON.stringify(d));

          if (json.error) {
            this.errorMsg = json.message;
          } else {
            alert(json.message);
          }
        },
        (e) => {
          this.globalServices.hideProgressbar();
        }
      );
  }
}
